import { ReportConfig } from "../definitions";
import affiliatePaidProductionReport from "./affiliatePaidProductionReport";
import affiliatePaidReport from "./affiliatePaidReport";
import affiliateWrittenReport from "./affiliateWrittenReport";
import annualGrowthTrend from "./annualGrowthTrend";
import branchExecutiveSummary from "./branchExecutiveSummary";
import branchMonthlyBreakdownReport from "./branchMonthlyBreakdownReport";
import brokerPaidReport from "./brokerPaidReport";
import brokerWrittenReport from "./brokerWrittenReport";
import companyPaidReport from "./companyPaidReport";
import companyWrittenReport from "./companyWrittenReport";
import dashboard from "./dashboard";
import dashboard2 from "./dashboard2";
import deliveryAgentReport from "./deliveryAgentReport";
import deliveryBranchReport from "./deliveryBranchReport";
import deliveryCompanyReport from "./deliveryCompanyReport";
import executiveSummary from "./executiveSummary";
import monthlyProductionReport from "./monthlyProductionReport";
import policyExportAll from "./policyExportAll";

const reports = [
  annualGrowthTrend,
  branchExecutiveSummary,
  dashboard,
  dashboard2,
  affiliateWrittenReport,
  affiliatePaidReport,
  executiveSummary,
  policyExportAll,
  brokerWrittenReport,
  brokerPaidReport,
  affiliatePaidProductionReport,
  companyPaidReport,
  companyWrittenReport,
  deliveryCompanyReport,
  deliveryBranchReport,
  deliveryAgentReport,
  monthlyProductionReport,
  branchMonthlyBreakdownReport,
];

export interface ReportFolder {
  title: string;
  reports: ReportConfig[];
}

export const groupedReports: ReportFolder[] = [
  {
    title: "DIS Business Stats",
    reports: [
      annualGrowthTrend,
      branchExecutiveSummary,
      executiveSummary,
      policyExportAll,
      affiliatePaidProductionReport,
      deliveryBranchReport,
      monthlyProductionReport,
      branchMonthlyBreakdownReport,
    ],
  },
  {
    title: "Agent Reports",
    reports: [brokerWrittenReport, brokerPaidReport, deliveryAgentReport],
  },
  {
    title: "Affiliate/Company Reports",
    reports: [
      affiliateWrittenReport,
      affiliatePaidReport,
      companyWrittenReport,
      companyPaidReport,
      deliveryCompanyReport,
    ],
  },
  {
    title: "Dashboards",
    reports: [dashboard, dashboard2],
  },
];

export default reports;
